const { makeStyles } = require('@mui/styles');

export const useStyles = makeStyles(() => ({
  partners: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(180deg, var(--Colors-Secondary04-1000, #00183A) 0%, #080812 100%)',
  },
  content: {
    width: '80vw',
    padding: '5vh',
    display: 'flex',
    flexDirection: 'column',
  },
  heading: {
    color: '#F3F5FB',
    textAlign: 'center',
    fontSize: '2.6vh',
  },
  swiperContainer: {
    padding: '5vh 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    width: '200px',
    margin: '0 auto',
    height: 'auto',
    objectFit: 'cover',
    display: 'flex',
    cursor: 'pointer',
  },
}));
